<form id="payment-form" (submit)="submit($event)">
  <div class="mb-4" id="payment-element"></div>
  <button *ngIf="showButton" type="submit" class="btn btn-secondary w-100 py-3">Create</button>
  <div id="payment-message" class="hidden"></div>
</form>
